import React, { useState } from "react";
import "../assets/css/donation.css";
import PayPalButton from "../components/donation/paypal";
import RazorPayForm from "../components/donation/razorpay_form";
import QrCode from "../components/donation/qr_code";

const PaymentOptions = ({ selectedPlan }) => {
  const [activePaymentMethod, setActivePaymentMethod] = useState(null);

  return (
    <div className="container">
      <center>
        <h2 style={{ padding: "20px" }}>How do you want to pay?</h2>
      </center>
      <div className="row payment-options-row">
        <QrCode
          setActivePaymentMethod={setActivePaymentMethod}
          activePaymentMethod={activePaymentMethod}
        />
        <PayPalButton
          setActivePaymentMethod={setActivePaymentMethod}
          activePaymentMethod={activePaymentMethod}
          selectedPlan={selectedPlan}
        />
        <RazorPayForm
          setActivePaymentMethod={setActivePaymentMethod}
          activePaymentMethod={activePaymentMethod}
          selectedPlan={selectedPlan}
        />
      </div>
    </div>
  );
};

export default PaymentOptions;
